<app-ds-recent-search 
  [dataType]="dataType"
  [from]="airSearch.from"
  [to]="airSearch.to"
  [isOneWay]="!airSearch.roundtrip"
  [startDate]="formatDate(airSearch.departuredate)"
  [endDate]="formatDate(airSearch.arrivaldate)"
  [paxNumber]="getFlightPassengers"
  [tooltipText]="getNamePlaces$ | async"
  [activateTooltip]="!isMobile"
  (clicked)="searchFlights()">
</app-ds-recent-search>